module.exports = __webpack_public_path__ + "static/media/logo-sidebar.50b4cb19.png";